import { Chart } from "react-chartjs-2";
import { Chart as ChartJS, registerables } from "chart.js";
import { Chart as ChartModel } from "../../../utils/models";

import withChart from "../../hoc/withChart";

const verticalOptions = {
  responsive: true,
  plugins: {
    legend: {
      position: "top" as const,
    },
    title: {
      display: true,
      text: "Chart.js Bar Chart",
    },
  },
  scales: {
    x: {
      display: true,
      grid: {
        drawOnChartArea: false,
      },
    },
    y: {
      display: true,
      grid: {
        drawOnChartArea: false,
      },
    },
  },
};

ChartJS.register(...registerables);

const Bar = (props: ChartModel): JSX.Element => {
  return (
    <Chart
      ref={props.chartRef}
      type="bar"
      data={props.chartData}
      options={verticalOptions}
    />
  );
};

export default withChart(Bar);
